import { materialDraftSchema, type MaterialDraft } from "./contracts";

const berlinDate = (now: Date) => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Berlin", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
export function interpretMaterial(text: string, now: Date): { draft: MaterialDraft; warnings: string[] } | null {
  if (!Number.isFinite(now.getTime())) throw new Error("INVALID_NOW");
  // Deliberately narrow grammar. A hint is never a resolved business object ID.
  const match = text.trim().match(/^(?:Jarvis[,\s]+)?Baustelle (.+?) braucht (heute|morgen|\d{4}-\d{2}-\d{2}) (\d+(?:[.,]\d{1,3})?)\s*(Tonnen?|t|kg|m³|m²|m|Stück) (.+?)[.!]?$/i);
  if (!match) return null;
  const [, siteHint, day, amount, rawUnit, material] = match;
  const date = new Date(`${berlinDate(now)}T12:00:00Z`);
  if (day.toLowerCase() === "morgen") date.setUTCDate(date.getUTCDate() + 1);
  const neededOn = /^\d{4}-/.test(day) ? day : date.toISOString().slice(0, 10);
  const unit = /^t(?:onne[n]?)?$/i.test(rawUnit) ? "t" : rawUnit.toLowerCase() === "stück" ? "Stück" : rawUnit.toLowerCase();
  const parsed = materialDraftSchema.safeParse({ siteHint, material, quantity: amount.replace(",", "."), unit, neededOn, priority: "NORMAL" });
  if (!parsed.success) return null;
  return { draft: parsed.data, warnings: ["Baustelle anhand berechtigter Stammdaten zuordnen.", "Termin ist ein Tagesdatum; Uhrzeit und Lieferant sind offen.", "Entwurf prüfen und ausdrücklich bestätigen. Keine Bestellung."] };
}
